import { store } from '/store.js'

interface navel {
  page: {
    url: string
    title: string
    blueprint: string
  }
  children: [
    page: {
      url: string
      title: string
      blueprint: string
    }
  ]
}

export const useBreadcrumbs = () => {
  const route = useRoute()
  const mainNav = store?.navigations?.main?.tree
  const currentPath = route.path
  const breadcrumbs: navel[] = []

  if (!mainNav) return breadcrumbs

  mainNav.forEach((level1: navel) => {
    if (level1.page.url == currentPath) breadcrumbs.push(level1)

    level1.children.forEach((level2: navel) => {
      if (level2.page.url == currentPath) breadcrumbs.push(level1, level2)

      level2.children.forEach((level3: navel) => {
        if (level3.page.url == currentPath)
          breadcrumbs.push(level1, level2, level3)
      })
    })
  })

  return breadcrumbs.map((crumb) => {
    return {
      url: crumb?.page?.url,
      title: crumb?.page?.title,
      blueprint: crumb?.page?.blueprint,
    }
  })
}
